// Pure copy and gating for the transfer dialog, kept out of ui.ts so it is
// testable without a DOM.

// Client-side gating is deliberately shallow. The domain allowlist lives in
// ALLOWED_HD server-side; duplicating it here would be a second source of
// truth that drifts silently, so a bad domain is left to the API's 422 and the
// dialog only catches the two mistakes it can be certain about.
export function transferBlockedReason(input: string, currentOwner: string): string | null {
  const v = input.trim();
  if (!v) return "Enter the new owner's Rewind address.";
  if (!v.includes("@")) return "That doesn't look like an email address.";
  // Phrased in the third person deliberately. This dialog opens on the admin
  // path too, where the current owner is someone else — "You already own this
  // share" would then be telling an admin they own something they don't.
  if (v.toLowerCase() === currentOwner.trim().toLowerCase()) return "That is already the owner of this share.";
  return null;
}

export interface Consequence {
  kind: "keep" | "warn";
  text: string;
}

export function transferConsequences(grantCount: number, hasToken: boolean): Consequence[] {
  const out: Consequence[] = [];
  if (grantCount > 0) {
    const noun = grantCount === 1 ? "1 access link keeps" : `${grantCount} access links keep`;
    out.push({
      kind: "keep",
      text: `${noun} working. Their URLs do not change — recipients see no change at all.`,
    });
  }
  out.push({
    kind: "keep",
    text: "The friendly URL and every version stay put. Each link keeps pointing at the version it points at now.",
  });
  if (hasToken) {
    out.push({
      kind: "warn",
      text: "The upload token will be revoked. Anything still pushing versions with it — a CI job, a local rewind-protos setup — stops working until the new owner generates a new one.",
    });
  }
  return out;
}
